module.exports = __webpack_public_path__ + "assets/img/home-swiper-dot-active.2f38746b.png";